module.exports = __webpack_public_path__ + "static/media/ic_star_vote-web.cb126426.png";